import { render, staticRenderFns } from "./PrepareMed.vue?vue&type=template&id=2c338f95&scoped=true"
import script from "./PrepareMed.vue?vue&type=script&lang=js"
export * from "./PrepareMed.vue?vue&type=script&lang=js"
import style0 from "./PrepareMed.vue?vue&type=style&index=0&id=2c338f95&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c338f95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c338f95')) {
      api.createRecord('2c338f95', component.options)
    } else {
      api.reload('2c338f95', component.options)
    }
    module.hot.accept("./PrepareMed.vue?vue&type=template&id=2c338f95&scoped=true", function () {
      api.rerender('2c338f95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/treatment/PrepareMed.vue"
export default component.exports